import { praktikoInstance } from '@/axios';
/* eslint-disable no-param-reassign */

const presentsConfigurationModule = {
	actions: {
		clearPresentsByEmployee({ commit }) {
			commit('SET_GOTIT_PRESENTS', []);
		},
		async createPresent({ dispatch }, body) {
			await praktikoInstance.post('awards', body);
			dispatch('resetingPresentData');
		},
		async deletePresent({ dispatch }, id) {
			await praktikoInstance.delete(`awards/${id}`);
			dispatch('loadAllPresents');
		},
		async loadAllPresents({ commit }) {
			const { data: response } = await praktikoInstance.get('awards');
			commit('SET_PRESENTS', response);
		},
		async loadPresentsByEmployee({ commit }, employeeId) {
			const requests = [
				praktikoInstance.get(`/awards/employee/${employeeId}`),
				praktikoInstance.get(`/employee/${employeeId}/award`),
			];
			const [
				{ data: avaliablePresents },
				{ data: myPresents }] = await Promise.all(requests);
			commit('SET_PENDING_PRESENTS', avaliablePresents);
			commit('SET_GOTIT_PRESENTS', myPresents.awards);
		},
		async loadWonPresentsByEmployee({ commit }) {
			const { data: response } = await praktikoInstance.get('employee-role/award');
			commit('SET_GOTIT_PRESENTS', response);
		},
		async redeemPresent({ dispatch }, { presentId, employeeId }) {
			const url = 'employee-award';
			const body = { awardId: presentId, employeeId };
			await praktikoInstance.post(url, body);
			dispatch('loadPresentsByEmployee', employeeId);
		},
		resetingPresentData({ dispatch }) {
			dispatch('loadAllPresents');
			dispatch('setNewPresentData', null);
		},
		setEditingPresentId({ commit }, presentId) {
			commit('SET_EDITING_PRESENT_ID', presentId);
		},
		setNewPresentData({ commit }, newPresentData) {
			commit('SET_NEW_PRESENT_DATA', newPresentData);
		},
		async updatePresent({ dispatch }, { id, ...rest }) {
			await praktikoInstance.patch(`awards/${id}`, rest);
			dispatch('resetingPresentData');
			dispatch('setEditingPresentId', 0);
		},
		updatePresentAction({ dispatch }, present) {
			if (present) {
				const { name, points, id } = present;
				dispatch('setNewPresentData', { name, points });
				dispatch('setEditingPresentId', id);
			} else {
				dispatch('setNewPresentData', null);
				dispatch('setEditingPresentId', 0);
			}
		},
	},
	state: {
		editingPresentId: 0,
		newPresentData: null,
		presents: [],
		presentsByEmployee: {
			pending: [],
			gotIt: [],
		},
	},
	mutations: {
		SET_EDITING_PRESENT_ID(state, id) {
			state.editingPresentId = id;
		},
		SET_GOTIT_PRESENTS(state, presents) {
			state.presentsByEmployee.gotIt = presents;
		},
		SET_NEW_PRESENT_DATA(state, newPresentData) {
			state.newPresentData = { ...newPresentData };
		},
		SET_PENDING_PRESENTS(state, presents) {
			state.presentsByEmployee.pending = presents;
		},
		SET_PRESENTS(state, presents) {
			state.presents = presents;
		},
	},
	getters: {
		presentName(state) {
			return state.newPresentData ? state.newPresentData.name : '';
		},
		presentPoints(state) {
			return state.newPresentData ? state.newPresentData.points : 0;
		},
		flagEdit(state) {
			return !!state.editingPresentId;
		},
	},
};

export default presentsConfigurationModule;



// WEBPACK FOOTER //
// ./src/store/modules/presents/index.js